export const range = (start: number, end: number): number[] =>
  Array.from({ length: end - start }, (_v, k) => k + start);

const now = new Date();
const currYear = now.getFullYear();
const currMonth = now.getMonth();

export type CalendarIndexTypes = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export const calendarMonths = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec"
};

export const daysInMonth = (
  iYear: number = currYear - 13,
  iMonth: number = currMonth + 1
): { value: number; label: string }[] => {
  const days = 32 - new Date(iYear, iMonth - 1, 32).getDate();
  return range(1, days + 1).map(day => ({ label: `${day}`, value: day }));
};

export const monthsInYear = (iYear: number = currYear - 12): { value: number; label: string }[] => {
  const months = Number(iYear) === currYear - 12 ? 12 : 12;
  return range(1, months + 1).map(month => ({
    value: month,
    label: calendarMonths[month as CalendarIndexTypes]
  }));
};

export const yearOptions = (): { value: number; label: string }[] => {
  return range(currYear - 85, currYear + 1)
    .map(year => ({ value: year, label: `${year}` }))
    .reverse();
};

export const convertDateObjToISO = (date: { day: number; month: number; year: number }): string => {
  const day = String(date.day).length === 1 ? `0${date.day}` : date.day;
  const month = String(date.month).length === 1 ? `0${date.month}` : date.month;
  const year = date.year;

  const isoDate = new Date(`${year}-${month}-${day}`).toISOString();
  return isoDate;
};

export const convertISOToDateObj = (
  date: string
): {
  day: number;
  month: number;
  year: number;
} => {
  const year = new Date(date).getFullYear();
  const month = new Date(date).getMonth() + 1;
  const day = new Date(date).getDate();

  return { day, month, year };
};
